module.exports = __webpack_public_path__ + "assets/img/step-1-74f7ed25.png";